/* global DocumentTouch */
import config from '../config';

const { IS_SERVER } = config;

export function touchevents() {
  return !IS_SERVER && (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch);
}



// WEBPACK FOOTER //
// ./src/util/featureDetection.js